import React, { createContext, useContext, useState } from 'react';
import { LANGUAGE_ITEM_NAME } from './consts/consts';

export enum Languages {
  ENGLISH = 'English',
  HEBREW = 'עברית',
  RUSSIAN = 'Русский',
  ARABIC = 'العربية',
}

/** Default BCP-47 code; mirrors psifasbeetleutils.languages.DEFAULT_LANG. */
export const DEFAULT_LANG = 'iw';

type LanguageContextType = {
  language: Languages;
  changeLanguage: (lang: Languages) => void;
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Languages>(Languages.HEBREW);

  const changeLanguage = (lang: Languages) => {
    setLanguage(lang);
    sessionStorage.setItem(LANGUAGE_ITEM_NAME, lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = (): LanguageContextType => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const isRTL = (lang: Languages): boolean => {
  switch (lang) {
    case Languages.HEBREW:
    case Languages.ARABIC:
      return true;
    default:
      return false;
  }
};
